import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MdOutlineCalendarToday } from "react-icons/md";

import Profile from "../../assets/images/profilepic.png";
import Cross from "../../assets/icons/Cross.svg";

import TextInputField from "../InputFields/TextInputField";
import DropdownField from "../InputFields/DropDown";
import SearchBar from "../universal/SearchBar";
import Navbar from "../universal/Navbar";
import ImageUpload from "../universal/ImageUpload";
import { ProfileHooks } from "./Hooks/ProfileHooks";

const MyProfile = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.user);
  const {
    value,
    editProfile,
    setEditProfile,
    profileValues,
    handleChange,
    onChangeSearchBar,
    imageUrl,
    setImageUrl,
    handleUpdateProfile,
  } = ProfileHooks();

  return (
    <div className="App bg-[#191919] h-fit min-h-screen flex p-4">
      <Navbar />
      <div className="flex-1 md:pl-32 md:pt-0 pt-20">
        <div className="flex flex-col gap-4 h-full">
          <SearchBar placeholder={"Search"} value={value} onChangeSearchBar={onChangeSearchBar} />
          <div className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4">
            <div className="flex gap-4 items-center justify-center pb-10">
              <div className="p-6 bg-[#1F1F1F] w-[50vw] rounded-3xl py-10">
                <div className="flex justify-between items-center">
                  <p className="text-white text-2xl font-semibold">
                    {profileValues?.firstName} {profileValues.lastName}
                  </p>
                  <div className="flex items-center gap-3">
                    <button
                      className="py-3 px-6 rounded-xl text-sm font-semibold border border-yellow-400 text-yellow-400"
                      onClick={() => {
                        editProfile
                          ? setEditProfile((prevState) => !prevState)
                          : handleUpdateProfile();
                      }}
                    >
                      {editProfile ? " Update Profile" : "Confirm"}
                    </button>
                    {Boolean(userInfo?.roleCode) && (
                      <img
                        src={Cross}
                        alt="close"
                        className="cursor-pointer"
                        onClick={() => navigate("/")}
                      />
                    )}
                  </div>
                </div>
                <div className="flex flex-col items-center justify-center p-4 gap-3">
                  <ImageUpload
                    placeholderImage={profileValues?.profilePicUrl ?? Profile}
                    imageUrl={imageUrl}
                    setImageUrl={(value) => {
                      setImageUrl(value);
                      handleChange({ target: { name: "profilePicUrl", value: value } });
                    }}
                    isUpload={!editProfile}
                  />
                  {/* <p className='text-xs text-white text-opacity-50'> Upload Picture</p> */}
                </div>
                <div className="flex justify-between gap-8 mt-4">
                  <TextInputField
                    name={"firstName"}
                    labelText={"First Name"}
                    placeholder={"First Name"}
                    value={profileValues.firstName}
                    handleInputChange={handleChange}
                    disabled={editProfile}
                  />
                  <TextInputField
                    name={"lastName"}
                    labelText={"Last Name"}
                    placeholder={"Last Name"}
                    value={profileValues.lastName}
                    handleInputChange={handleChange}
                    disabled={editProfile}
                  />
                </div>
                <div className="flex justify-between gap-8 mt-4">
                  <DropdownField
                    name={"gender"}
                    placeholder={"Select Gender"}
                    labelText={"Gender"}
                    isDisabled={editProfile}
                    defaultValue={"male"}
                    options={[
                      {
                        roleName: "Male",
                        value: "male",
                        shortCode: "male",
                      },
                      {
                        roleName: "Female",
                        value: "female",
                        shortCode: "female",
                      },
                    ]}
                    handleInputChange={handleChange}
                    value={profileValues.gender}
                  />
                  <div className="w-full">
                    <p className="text-[12px] font-semibold text-greyish mb-1.5 pt-1">
                      Date of Birth
                    </p>
                    <DatePicker
                      disabled={editProfile}
                      selected={profileValues?.dob || null}
                      onChange={(value) => {
                        handleChange({ target: { name: "dob", value } });
                      }}
                      isClearable
                      showIcon={true}
                      showMonthDropdown={true}
                      showYearDropdown={true}
                      dropdownMode="select"
                      toggleCalendarOnIconClick={true}
                      placeholderText="MM/DD/YYYY"
                      icon={<MdOutlineCalendarToday className="mr-2 cursor-pointer" />}
                      wrapperClassName="mt-2 custom-datepicker w-full"
                      className="bg-greyishV2 stroke-white !p-3 !pl-8 w-full text-white text-[14px] font-medium leading-4 rounded-md"
                    />
                  </div>
                </div>
                <div className="flex mt-6">
                  <TextInputField
                    name={"aboutMe"}
                    labelText={"About me"}
                    placeholder={"About me"}
                    value={profileValues.aboutMe}
                    handleInputChange={handleChange}
                    disabled={editProfile}
                  />
                </div>
                <div className="flex justify-between gap-8 mt-4">
                  <TextInputField
                    name={"mobile"}
                    labelText={"Phone Number"}
                    placeholder={"Phone Number"}
                    value={profileValues.mobile}
                    handleInputChange={handleChange}
                    disabled={editProfile}
                  />
                  <TextInputField
                    name={"email"}
                    labelText={"Email ID"}
                    placeholder={"Email ID"}
                    value={profileValues.email}
                    handleInputChange={handleChange}
                    disabled={true}
                  />
                </div>
                <div className="flex mt-4">
                  <TextInputField
                    name={"country"}
                    labelText={"Country"}
                    placeholder={"Country"}
                    value={profileValues.country}
                    handleInputChange={handleChange}
                    disabled={editProfile}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
